// Wizard Step Definitions
export type WizardStepKey =
  | 'document_generation'
  | 'document_package'
  | 'signature_verification'
  | 'quickbooks_inactivation';

export interface WizardStep {
  key: WizardStepKey;
  title: string;
  description: string;
  order: number;
}

export const WIZARD_STEPS: WizardStep[] = [
  {
    key: 'document_generation',
    title: 'Document Generation',
    description: 'Generate termination letter',
    order: 1,
  },
  {
    key: 'document_package',
    title: 'Document Package',
    description: 'Prepare for signature',
    order: 2,
  },
  {
    key: 'signature_verification',
    title: 'Signature Verification',
    description: 'Track signed documents',
    order: 3,
  },
  {
    key: 'quickbooks_inactivation',
    title: 'QuickBooks Inactivation',
    description: 'Deactivate employee in QuickBooks',
    order: 4,
  },
];

// Wizard Draft Data
export interface WizardDraftData {
  employeeId?: string; // If employee is already created
  stepData?: Record<WizardStepKey, any>; // Step-specific data
  completedSteps?: WizardStepKey[]; // Steps marked as completed
  currentStep?: WizardStepKey;
  createdAt?: string;
  updatedAt?: string;
}

// Step Completion Status
export interface StepCompletionStatus {
  step: WizardStepKey;
  completed: boolean;
  completedAt?: string;
}

